import React, { useContext } from 'react'
import { AppContext } from '@state/context'
import {
  PANELS,
  PANEL_TRANSITION_TYPES,
} from '@helpers/constants'
import Panel from '../Panel'

const EditExercisePanel = (props) => {
  const {
    openPanels,
  } = props
  const [state] = useContext(AppContext)

  if (
    !state?.panels?.exercise ||
    (Object.keys(state.panels.exercise).length === 0 &&
      state.panels.exercise.constructor === Object)
  ) {
    return null
  }
  const {
    getComponent,
  } = state?.panels?.exercise

  return (
    <Panel
      visible={openPanels.includes(PANELS.EDIT_EXERCISE)}
      width={`${state?.panels?.sideBarWidth}px` ?? '40%'}
      transitionType={PANEL_TRANSITION_TYPES.FROM_LEFT}
      shadow={true}
    >
      {getComponent &&
        getComponent()
      }
    </Panel>
  )
}

export default EditExercisePanel
